
export default {
    props: {
        steps: { type: Array, required: true },
        activeId: { type: String, required: true },
    },
    computed: {
        activeIdx () {
            return Math.max(0, this.steps.findIndex(s => s.id === this.activeId))
        },
        activeStep () {
            return this.steps[this.activeIdx]
        },
    },
}
